import { userTypesList } from './constants';
import { log } from '../utility';
import { filterSlots } from './filterSlots';
import outbrain from './outbrain';
import viralize from './viralize';
import ampAds from './amp-ads';

const DIV_ID_PREFIX = 'div-gpt-ad-';

function executeTask(cmd) {
  if (typeof cmd === 'function') {
    cmd();
  }
}

function loadGPTScript() {
  const tag = document.createElement('script');
  tag.type = 'text/javascript';
  tag.src = 'https://www.googletagservices.com/tag/js/gpt.js';
  const node = document.getElementsByTagName('script')[0];
  node.parentNode.insertBefore(tag, node);
  window.googletag = window.googletag || { cmd: [] };
}

function defineSlot(slot, sizes, divId, outOfPage) {
  log('Add GPT definition for', slot);
  const googletag = window.googletag;
  if (outOfPage) {
    googletag.cmd.push(function () {
      googletag.defineOutOfPageSlot(slot, divId).addService(googletag.pubads());
      log('GPT defined', slot);
    });
  } else {
    googletag.cmd.push(function () {
      googletag.defineSlot(slot, sizes, divId).addService(googletag.pubads());
      log('GPT defined', slot);
    });
  }
}

function enableServices() {
  const googletag = window.googletag;
  googletag.cmd.push(function () {
    googletag.pubads().enableLazyLoad();
    googletag.pubads().enableSingleRequest();
    // collapsing empty divs raises CLS
    googletag.pubads().collapseEmptyDivs();
    googletag.pubads().setCentering(true);
    googletag.enableServices();
  });
}

function setPageTargeting() {
  const googletag = window.googletag;
  const pcp = window.pcp;
  const targetingDict = pcp.MonrifPolopolyUtility.TagManager || {};
  targetingDict.device = pcp.device;
  if (pcp.thirdLevelDomain) targetingDict.site = pcp.thirdLevelDomain;
  googletag.cmd.push(function () {
    for (const key in targetingDict) googletag.pubads().setTargeting(key, targetingDict[key]);
  });
}

function getSlotOptions(slotName, advSlotList) {
  for (let i = 0; i < advSlotList.length; i++) {
    if (advSlotList[i].unit === slotName) {
      return advSlotList[i];
    }
  }
}

function init(slots) {
  window.pcp = {
    define: function (path, positions, device) {
      log(path, positions);
      log('Device', device);
      const pcp = window.pcp;
      pcp.device = device;
      if ('globals' in window) {
        pcp.thirdLevelDomain = window.globals.customDomain;
      }
      pcp.MonrifPolopolyUtility = window.MonrifPolopolyUtility || {};
      log('Load GPT');
      loadGPTScript();
      pcp.__defined = [];
      for (let i = 0; i < positions.length; i++) {
        const slotName = positions[i];
        const slotOptions = getSlotOptions(slotName, slots);
        if (slotOptions) {
          if (slotOptions.device !== pcp.device) {
            continue;
          }
          let adUnitPath = path;
          if ('custom_adunit_dir' in slotOptions && slotOptions.custom_adunit_dir !== '') {
            const speedConf = (pcp.MonrifPolopolyUtility.aggregatorValues || {}).speed || {};
            adUnitPath = speedConf.code || '';
            adUnitPath += slotOptions.custom_adunit_dir.replace(/\{[^}]+\}/gi, function (m) {
              const key = m.substring(1, m.length - 1).toLowerCase();
              if (key in speedConf) return speedConf[key];
              return '';
            });
            if (!adUnitPath.match(/\/$/)) adUnitPath += '/';
          }
          adUnitPath += positions[i];
          defineSlot(
            adUnitPath,
            slotOptions.sizes,
            DIV_ID_PREFIX + slotName,
            slotOptions.outOfPage,
          );
          pcp.__defined.push(DIV_ID_PREFIX + slotName);
        } else {
          console.warn(slotName, 'not defined');
        }
      }
      setPageTargeting();
      enableServices();
    },
    push: function (cmd) {
      executeTask(cmd);
    },
    display: function (divId) {
      const pcp = window.pcp;
      if (pcp.__defined.indexOf(divId) === -1) {
        log(divId, 'not defined');
        return;
      }
      window.googletag.cmd.push(function () {
        window.googletag.display(divId);
      });
    },
  };
  for (let i = 0; i < pending.length; i++) {
    executeTask(pending[i]);
  }
}

window.pcp = window.pcp || [];
const pending = window.pcp;
log('Pending tasks', pending);

window.requireConsent = window.requireConsent || [];

export const pcp2Init = (userType) => {
  const { globals = {} } = window;

  const slots = filterSlots(userTypesList, userType, globals.isArticle, globals.isMobile);
  init(slots);
  outbrain(userType);
  viralize(userType);
  ampAds(userType);
};
